export default __webpack_public_path__ + "static/media/con-desactivar.4f03fc58.svg";